import React from "react";
import ContractFromContainer from "components/containers/ContractFormContainer/ContractFormContainer";


function ContractFromRoute(){
  return(
     <ContractFromContainer/>
  )
}

export default ContractFromRoute;
